import React,{ Component } from 'react';
import { Table } from 'reactstrap';
import { Button, FormGroup, Input } from 'reactstrap';
import { Container, Col } from 'reactstrap';
import { Offline, Online } from "react-detect-offline";


export default class TableColumnRow extends Component {
    constructor(props){
    	super(props);
    	this.state = {
          text: 'Sync my data'
      };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            this.setState({ text: 'Sync my data' });
        }
    }

    mountTableHeaders(rows) {
      return (
        <>
          <th key="OutputColumnName">Output Column Name</th>
          <th key="InputColumnName">Input Column Name</th>
        </>
      )
    }

    mountTableBody(rows) {
        let body = [];
        for (var i = 1; i < rows.length; i++) {
            
            body.push(
                <tr key={rows.length + i}>
                  {this.innerTableContent(rows[i], i)}
                </tr>
            );
        }

        return body;
    }

    innerTableContent(row, count) {
      const { headers } = this.props;
      return (
        <>
          <td key={row._id}>{row.title}</td>
          {/* <td key={row._id+"dropdown"}>{this.dropDownContent(row.name, count)}</td> */}
          <td key={row._id+"dropdown"}>
            <Input
                type="select"
                name={row.name}
                id={row.name}
                placeholder="Select Column"
                // value={this.props.selectedReport}
                onChange={this.handleHeaderChange.bind(this)}
              >
                <option value='default' key={0}>Select Option</option>
                {
                  headers.map((option, i) => <option value={option} key={i}>{option}</option>)
                }
              </Input>
          </td>
        </>
      )
    }

    dropDownContent(name, count) {
      const { headers } = this.props;
      const that = this;
        return (
          <>
            {/* <td key={count}> */}
              <Input
                type="select"
                name={name}
                id={name}
                placeholder="Select Column"
                // value={this.props.selectedReport}
                onChange={this.handleHeaderChange.bind(this)}
              >
                <option value='default' key={0}>Select Option</option>
                {
                  headers.map((option, i) => <option value={option} key={i}>{option}</option>)
                }
              </Input>
            {/* </td> */}
          </>
        )
    }

    handleHeaderChange(e) {
      const { target: { value, name } } = e;
      const { columnsRowsMapping, setColumnsRowsMapping } = this.props;
      
      const obj = {};
      obj[name] = value;

      let mappingColumns = columnsRowsMapping || [];
      mappingColumns.push(obj);

      
    }

    syncData() {
        this.setState({ text: 'Data sync successfull!! '});
    }

    renderButtons() {
        const { text } = this.state;

        return (
          <FormGroup
            key='render-buttons-form-group'
          >
              {/* <Col>
                <Button
                  color="primary"
                  onClick={this.props.clearData}
                  >
                  Clear data
                </Button>
                <Online>
                   <Button
                      color="success"
                      onClick={this.syncData.bind(this)}
                    >
                     {text}
                   </Button>
                </Online>
              </Col> */}
              <Col>
                <Offline>
                   You must be online to sync your data! Active your internet connection.
                </Offline>
              </Col>
          </FormGroup>
        );
    }

    render() {
        const { rows } = this.props;
        if (rows.length > 0) {
            return(
                <Container>
                  {this.renderButtons()}
                  <Table
                    hover
                    responsive
                    >
                    <thead>
                      <tr>
                        {this.mountTableHeaders(rows)}
                      </tr>
                    </thead>
                    <tbody>
                      {this.mountTableBody(rows)}
                    </tbody>
                  </Table>
                </Container>
            );
        }

        return null;
  }
}
